/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Invite_FromInputs */

const en_invite_from = /** @type {(inputs: Invite_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} invited you to Dishly.`)
};

const de_invite_from = /** @type {(inputs: Invite_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hat dich zu Dishly eingeladen.`)
};

/**
* | output |
* | --- |
* | "{name} invited you to Dishly." |
*
* @param {Invite_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_from = /** @type {((inputs: Invite_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_from(inputs)
	return en_invite_from(inputs)
});